<template>
  <div class="h-screen w-screen flex flex-col items-center justify-center">
    <h1>ups pagina no encontrada</h1>
    <a href="/dashboard">Go to dashboard</a>
  </div>
</template>
